/**
 * PaymentForm requires Paysafe.js plugin from {@link module:lib/paysafe/promise}.
 * So as not to overcrowd the component file, this file contains all of the
 *   logic for setting up and handling the Paysafe plugin.
 */

import logger from "lib/log";
import * as paysafePromise from "lib/paysafe/promise";

// get options from ENV
export const apiKey = process.env.REACT_APP_PAYSAFE_API_KEY;
export const environment = process.env.REACT_APP_PAYSAFE_ENVIRONMENT;

// helpful for debugging
logger.debug("paysafe API key:", apiKey);
logger.debug("paysafe environment:", environment);

/**
 * paysafe.fields.setup with our options.
 * @returns {Promise}
 */
export function setup() {
  return paysafePromise.setup(apiKey, {
    environment,
    fields: {
      cardNumber: {
        selector: "#paysafeCardNumber",
        placeholder: "xxxx xxxx xxxx xxxx"
      },
      cvv: {
        selector: "#paysafeCvv",
        placeholder: "xxx"
      },
      expiryDate: {
        selector: "#paysafeExpiryDate",
        placeholder: "mm / yy"
      }
    },
    style: {
      "input": {
        "font-size": "14px"
      }
    }
  });
}

/**
 * paysafe~instance.tokenize with our options.
 * Require some details from the component.
 * @returns {Promise}
 */
export function tokenize(instance, amount, school, cardHolderName) {
  return paysafePromise.tokenize(instance, {
    threeDS: {
      amount,
      currency: "GBP",
      accountId: school.paysafeAccountNumber
    },
    value: {
      cardHolderName
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/paysafe/paysafe.js